<template>
  <LoginLayout
    class="login-otp__layout"
    :title="isMobileScreen && title"
    :subtitle="
      isMobileScreen && t('Please enter your OTP (One-Time Password) generated')
    "
    :showLogo="isMobileScreen"
    :showBackButton="isMobileScreen"
    @goBack="$emit('goBack')"
  >
    <template #body>
      <OverviewCardLayout class="login-otp__card">
        <!-- Desktop /IPAD header -->
        <template #left-title-element>
          <BackButton :showBtnText="false" @on-back-click="$emit('goBack')" />
        </template>
        <template #title>
          {{ title }}
        </template>

        <!-- Login OTP Form -->
        <LoginOTPForm />
      </OverviewCardLayout>
    </template>
  </LoginLayout>
</template>

<style lang="scss">
.login-otp {
  &__card {
    z-index: $non-auth-z-index;
    width: $non-auth-width;
    margin: $non-auth-layout-margin 0px;
  }

  // IPAD, mobile screens and below
  @media screen and (max-width: $screen-lg) {
    &__layout {
      .login-layout__form {
        padding: $overview-card-padding;
      }
    }
  }
  // Mobile Screens
  @media screen and (max-width: $screen-sm) {
    &__card {
      width: 100%;
      margin: unset;
      border: unset;

      &.overview-card-layout {
        .ant-card-head {
          display: block;
        }
        .ant-card-body {
          padding: 0;
        }
      }
    }
    &__layout {
      .login-layout__form {
        border-color: transparent;
      }
    }
  }
}
</style>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { useI18n } from "vue-i18n";
import { makeRequiredRule } from "@/shared/utils/validators/commonValidators";
import LoginLayout from "@/shared/components/layouts/LoginLayout.vue";
import LoginOTPForm from "@/shared/components/forms/LoginOTPForm.vue";
import { windowSizeSimpleStore } from "@/shared/store/simpleStore/windowSizeData";
import BackButton from "@/shared/components/buttons/BackButton.vue";
import OverviewCardLayout from "@/shared/components/layouts/OverviewCardLayout.vue";

export default defineComponent({
  setup() {
    const t = useI18n().t;
    const isMobileScreen = computed(() => windowSizeSimpleStore.isMobile);

    return {
      t,
      isMobileScreen,
      title: t("One-Time Password"),
    };
  },
  emits: ["goBack"],
  methods: {
    makeRequiredRule,
  },
  components: {
    LoginLayout,
    LoginOTPForm,
    BackButton,
    OverviewCardLayout,
  },
});
</script>
